<header *ngIf="(!isMobile && showBanner) || (isMobile && showBannerOnMobile)">
  <ng-container>
    <div class="logo-section">
      <ng-container *ngIf="logo">
        <ng-container *ngIf="logoUrl; else noLogoUrl">
          <a [href]="logoUrl" target="_blank">
            <img
              [src]="logo"
              [ngStyle]="{height: 'var(--form-logo-size, '+logoHeight+')'}"
              alt="company-logo"
            />
          </a>
        </ng-container>
        <ng-template #noLogoUrl>
          <img
            [src]="logo"
            [ngStyle]="{ height: logoHeight }"
            alt="company-logo"
          />
        </ng-template>
      </ng-container>
    </div>
    <div class="address-section">
      <ul>
        <li *ngIf="address">
          <img src="assets/icon/marker.svg" /><p>{{ address }}</p>
        </li>

        <li *ngIf="phoneNumber && !isMobile">
          <a class="flex" [href]="'tel:' + phoneNumber">
            <img src="assets/icon/phone.svg" /><p>{{ phoneNumber }}</p>
          </a>
        </li>

        <li *ngIf="textNumber && !isMobile">
          <img src="assets/icon/phone.svg" /><p>{{ textNumber }}</p>
        </li>
      </ul>
    </div>
  </ng-container>
</header>
<div
  class="spacer"
  *ngIf="(!showBanner && !isMobile) || (!showBannerOnMobile && isMobile)"
></div>
